import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import './css/styles.css';

import MainPage from './components/projects/';
import DetPage from './components/projects/detPage';

import ProjectDetail from './components/detail/';
//import ScrollToTop from './components/global/scroll';
import { setLocal, getLocal, logout } from './actions';

function toSearch() {
    return <Redirect to="/search" />;
}

class App extends Component {

    render() {

        return (
            // <ScrollToTop>
            <div className="App">
                <Switch>
                    <Route path="/projects/:projectId/" component={ProjectDetail} />

                    <Route exact
                        path="/:filter(my-projects|aeProjects|search|watchlist|reports|factsheet|aeSearch|studioMgmt|fepLite)/:page?"
                        component={(props) => <MainPage {...props} />}
                    />

                    <Route exact path="/redirect" render={(data) => {
                        const access_code = data.location.search.split('=')[1];
                        const toPath = getLocal('redirect_url') || '/search';
                        setLocal('access_code', access_code)
                        setLocal('refresh_token', '');
                        return <Redirect to={toPath} />
                    }} />

                    <Route exact path="/logout" render={logout} />

                    <Route exact path="/projects" render={toSearch} />
                    <Route exact path="/" component={(props) => <DetPage {...props} />} />
                    
                </Switch>
            </div>
            // </ScrollToTop>
        );
    }
}

export default App;
